/**
 * @file voidedDocument.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-05
 * @modified 2026-10-05
 * @description A voided invoice, credit note or bill cannot be edited or
 *              restored, here or in Xero (Cam, 2026-10-05). These say whether
 *              a document is voided and where "Raise a copy" takes it
 *              (components/VoidedDocumentDialog).
 */

import { INVOICE_FROM_ORDER_KEY } from './invoiceFromOrder';

/** sessionStorage keys the create screens read on mount for a copy. */
export const COPY_INVOICE_KEY = 'copyInvoiceId';
export const COPY_BILL_KEY = 'copyBillId';

/** Is this status VOIDED (any case)? */
export const isVoided = (status) => String(status || '').toUpperCase() === 'VOIDED';

/**
 * Where "Raise a copy" goes for a voided document.
 * @param {'invoice'|'bill'} kind
 * @param {object|null} doc — GET /api/documents/voided/:kind/:id `document`
 * @returns {{ menu: string|null, storageKey: string|null, label: string, what: string, blocked: string|null }}
 */
export function copyTarget(kind, doc) {
  if (kind === 'bill') {
    return {
      menu: 'create-bill', storageKey: COPY_BILL_KEY, label: 'Add Bill',
      what: 'the same supplier, POs, lines and prices, as a Draft', blocked: null
    };
  }
  if (doc?.fromTill) {
    return {
      menu: null, storageKey: null, label: 'Till Sales', what: 'the sale',
      blocked: 'A till invoice is raised again from Till Sales: voiding it released the sale there, so invoice it from Till Sales.'
    };
  }
  if (doc?.customerOrderId) {
    return {
      menu: 'create-invoice', storageKey: INVOICE_FROM_ORDER_KEY, label: 'Add Invoice',
      what: `${doc.orderNumber ? `order ${doc.orderNumber}` : 'its order'} filled in (voiding the invoice put the order back to not invoiced)`,
      blocked: null
    };
  }
  const credit = !!doc?.isCredit;
  return {
    menu: credit ? 'create-credit-note' : 'create-invoice', storageKey: COPY_INVOICE_KEY,
    label: credit ? 'Add Credit Note' : 'Add Invoice',
    what: 'the same contact, lines and prices, under a new number', blocked: null
  };
}
